import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Check, Star, TrendingUp, Crown } from 'lucide-react'

const plans = [
  {
    name: 'مجاني',
    price: '0',
    period: 'دائم',
    description: 'للمتاجر الصغيرة والناشئة',
    icon: Star,
    features: [
      'نشر 5 منتجات كحد أقصى',
      'إنشاء كتالوج واحد كحد أقصى',
      'دعم فني أساسي',
    ],
    buttonText: 'ابدأ الآن',
    variant: 'outline',
    popular: false,
  },
  {
    name: 'أساسي',
    price: '25',
    period: 'شهر',
    description: 'للمتاجر المتوسطة',
    icon: TrendingUp,
    features: [
      'نشر 15 منتجاً كحد أقصى',
      'إنشاء 4 كتالوجات كحد أقصى',
      'دعم فني优先',
    ],
    buttonText: 'اختر الخطة',
    variant: 'default',
    popular: false,
  },
  {
    name: 'قياسي',
    price: '70',
    period: 'شهر',
    description: 'للمتاجر النشطة',
    icon: Check,
    features: [
      'نشر 25 منتجاً كحد أقصى',
      'إنشاء 8 كتالوجات كحد أقصى',
      'إحصائيات متقدمة',
      'دعم فني على مدار الساعة',
    ],
    buttonText: 'اختر الخطة',
    variant: 'default',
    popular: true,
  },
  {
    name: 'احترافي',
    price: '150',
    period: 'شهر',
    description: 'للمتاجر الكبرى والعلامات التجارية',
    icon: Crown,
    features: [
      'نشر عدد غير محدود من المنتجات',
      'إنشاء كتالوجات غير محدودة',
      'إحصائيات متقدمة',
      'ترقية المنتجات عبر الإعلانات',
      'مدير حساب مخصص',
    ],
    buttonText: 'اختر الخطة',
    variant: 'default',
    popular: false,
  },
]

export function PricingTable({ onSelectPlan, loading = false }) {
  if (loading) {
    return (
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => (
          <Card key={i} className="animate-pulse">
            <CardHeader className="h-32 bg-muted rounded-t-lg" />
            <CardContent className="h-64" />
          </Card>
        ))}
      </div>
    )
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4" dir="rtl">
      {plans.map((plan) => (
        <Card
          key={plan.name}
          className={`relative flex flex-col transition-all duration-200 hover:shadow-lg ${
            plan.popular ? 'border-brand shadow-md' : ''
          }`}
        >
          {plan.popular && (
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full border border-brand bg-background text-brand text-xs font-semibold px-3 py-1">
              الأكثر طلباً
            </div>
          )}
          <CardHeader className="text-center pb-4">
            <div
              className={`mx-auto mb-3 p-2 rounded-full w-12 h-12 flex items-center justify-center border ${
                plan.popular ? 'border-brand' : 'border-transparent bg-primary/10'
              }`}
            >
              <plan.icon className={`h-6 w-6 ${plan.popular ? 'text-brand' : 'text-primary'}`} />
            </div>
            <CardTitle className="text-2xl">{plan.name}</CardTitle>
            <CardDescription>{plan.description}</CardDescription>
            <div className="mt-2">
              <span className="text-3xl font-bold">{plan.price}</span>
              <span className="text-muted-foreground"> درهم / {plan.period}</span>
            </div>
          </CardHeader>
          <CardContent className="flex-1 flex flex-col">
            <ul className="space-y-2 mb-6 text-sm">
              {plan.features.map((feature, idx) => (
                <li key={idx} className="flex items-center gap-2">
                  <Check className={`h-4 w-4 shrink-0 ${plan.popular ? 'text-brand' : 'text-primary'}`} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <Button
              variant={plan.popular ? 'outline' : plan.variant}
              className={`w-full mt-auto ${plan.popular ? 'border-brand text-brand hover:bg-brand/5 hover:text-brand' : ''}`}
              onClick={() => onSelectPlan?.(plan.name)}
            >
              {plan.buttonText}
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}